<template>
	<div class="product-configrator">
    <div class="content">
      <div class="form-field">
        <label>{{$_('width')}}</label>
        <Select 
          :data="this.$store.getters['produit/get_product_config_width']" 
          :itemoption="['TTAIL', 'TLIB_TAIL']"
          :placeholder="$_('width_choice_placeholder')" 
          @select-change="vSelectedStore('ttail', $event)" 
          :selectvalue="select_ttail"
          :resetselect="reset"
        />
      </div>
      <div class="form-field">
        <label>{{$_('packaging')}}</label>
        <Select 
          :data="this.$store.getters['produit/get_product_config_packaging']"  
          :itemoption="['TOPT', 'TLIB_OPT']"
          :placeholder="$_('packaging_choice_placeholder')"
          @select-change="vSelectedStore('fopt', $event)" 
          :selectvalue="select_fopt"
          :resetselect="reset"
        />
      </div>
      <div class="form-field">
        <label class="label-color">{{$_('color')}}</label>
        <small>{{$_('color_sentence')}}</small>
        <ColorSelect 
          :colors="getColorData" 
          :resetcolor="reset"
        />    
      </div>
    </div>
    <CustomModal 
      :title="'ATTENTION'"
      :open="open"
      :size="'xs'"
      :keepratio="true"
      @close-modal="open = false">
      <template slot="modal_content">
        <h2 class="modal-content">{{$_('choice_not_available')}}</h2>
      </template>
      <template slot="modal_footer">
        <div class="btn-reinit-config">
          <div class="form-field">
            <button @click="vReinit" class="btn">{{$_('yes').toUpperCase()}}</button>
          </div>
          <div class="form-field">
            <button class="btn" @click="open = false">{{$_('no').toUpperCase()}}</button>
          </div>
        </div>
      </template>
    </CustomModal>
  </div>
</template>

<script>

import productService from '@/modules/produit/services/productService';
import Select from '@/common/components/widget/Select';
import ColorSelect from '@/modules/produit/components/ColorSelect';

import CustomModal from '@/common/components/widget/Modal/CustomModal'

export default {
  components: {
    Select,
    ColorSelect,
    CustomModal
  },
  data() {
    return {
      open: false,
      option_key: '',
      option_val: '',
      reset: false,
      select_ttail: { id: ''},
      select_fopt: { id: '' },
      select_col: { id: '' }
    }
  },
  created() {
    this.vGetProductInfo();
  },
  computed: {
    getLaunchConfig() {
      return this.$store.getters['produit/get_launch_config']
    },
    getColorData() {
      return this.$store.getters['produit/get_product_config_color']
    }
  },
  methods: {
    vGetProductInfo() {
      return productService.getProductInfo({
        fmod: this.$store.getters['produit/get_fmod']  !== '' ? this.$store.getters['produit/get_fmod'] : null,
        ftail1: this.$store.getters['produit/get_ftail1']  !== '' ? this.$store.getters['produit/get_ftail1'] : null,
        ftail2: this.$store.getters['produit/get_ftail2']  !== '' ? this.$store.getters['produit/get_ftail2'] : null,
        fopt: this.$store.getters['produit/get_fopt']  !== '' ? this.$store.getters['produit/get_fopt'] : null,
        fcol: this.$store.getters['produit/get_fcol']  !== '' ? this.$store.getters['produit/get_fcol'] : null,
        fmarq: this.$store.getters['produit/get_fmarq']  !== '' ? this.$store.getters['produit/get_fmarq'] : null,
        fgrpcol: this.$store.getters['produit/get_fgrpcol']  !== '' ? this.$store.getters['produit/get_fgrpcol'] : null,
      })
      .then(res => {
        // INFO PRODUIT GENERAL
        this.$store.dispatch('produit/SELECT', {key: 'descm_long', value: res.data.DESCM_LONG});
        this.$store.dispatch('produit/SELECT', {key: 'descm_court', value: res.data.DESCM_COURT});
        this.$store.dispatch('produit/SELECT', {key: 'desc_prod', value: res.data.DESC_PROD});
        this.$store.dispatch('produit/SELECT', {key: 'compo', value: res.data.COMPO});
        this.$store.dispatch('produit/SELECT', {key: 'division_img', value: res.data.DS_ODIV.OUT});
        this.$store.dispatch('produit/SELECT', {key: 'collection_card', value: res.data.DS_OCARTE.OUT});

        // CONDITIONNEMENT
        if( res.data.DS_O3 !== undefined) {
          let topt_temp = Array();

          res.data.DS_O3.OUT.map(obj => {
            topt_temp.push({
              TOPT: obj.TOPT,
              TLIB_OPT: obj.TLIB_OPT,
              activate: obj.TOK3
            });
          });
          this.$store.dispatch('produit/SELECT', {key: 'product_config_packaging', value: topt_temp});
        }
        // TAILLE
        if( res.data.DS_O4 !== undefined) {
          let ttail_temp = Array();

          res.data.DS_O4.OUT.map(obj => {
            ttail_temp.push({
              TTAIL: obj.TTAIL1+'_'+obj.TTAIL2,
              TLIB_TAIL: obj.TTAIL1+obj.TTAIL2,
              activate: obj.TOK4
            });
          });
          this.$store.dispatch('produit/SELECT', {key: 'product_config_width', value: ttail_temp});
        }
        // COLORIS
        if( res.data.DS_O5 !== undefined) {
          this.$store.dispatch('produit/SELECT', {key: 'product_config_color_reference', value: res.data.DS_O5.OUT});
          this.$store.dispatch('produit/SELECT', {key: 'product_config_color', value: res.data.DS_O5.OUT});
        }
        this.$store.dispatch('produit/SELECT', {key: 'launch_config', value: false});
        this.$store.dispatch('produit/LAUNCH_STOCK');
        this.$store.dispatch('produit/LAUNCH_PRICE');
      });
    },
    vSelectedStore(key, value) {

      if(value.activate === 0) {
        this.open = true;
        this.option_key = key;
        this.option_val = value.item;
        
        return false;
      }
  
      if(key === 'ttail') {

        if(value.item === '') {
          this.$store.dispatch('produit/SELECT', {key: 'ftail1', value: ''});
          this.$store.dispatch('produit/SELECT', {key: 'ftail2', value: ''});
        } else {
          let ttail = value.item.split('_');
          this.$store.dispatch('produit/SELECT', {key: 'ftail1', value: ttail[0]});
          this.$store.dispatch('produit/SELECT', {key: 'ftail2', value: ttail[1]});
        }

      } else {
        this.$store.dispatch('produit/SELECT', {key, value: value.item});
      }

      this.vGetProductInfo();  
    },
    vReinit() {

      this.reset = true;
      this.open = false; 

      setTimeout(() => {
        this.reset = false;
      }, 500);
    }
  },
  watch: {
    getLaunchConfig(val) {
      if(val) {
        this.vGetProductInfo();
      }
    }
  }
}

</script>

<style scoped>
.content label {
  display: block;
  margin-left:30px;
}
.content small {
  margin-left:30px;
  display: block;
  margin-top: 5px;
  font-family: 'Lato-Regular';
}
.select-box {
  width: 270px;
}
.product-btn-container {
  display: flex;
  margin-top: 20px;
  padding: 0px 10px;
}
.product-btn-container > div {
  flex: 1;
}
.btn-reinit-config {
  display: flex;
  justify-content: center;
}
.btn-reinit-config .form-field {
  margin-right: 15px;
}
h2.modal-content {
  text-align: center;
}
</style>